import React from 'react';
import { useMutation } from '@apollo/client';
import withLoginRequiredToken from '@catalogo/service-americanas-common/src/hocs/login-required-token';
import compose from 'lodash/fp/compose';
import { getIn } from 'seamless-immutable';
import { withMetrics } from '@catalogo/core-metrics';
import { withCustomer } from '@catalogo/core-connect/customer';
import { addQuestion as addQuestionQuery } from '../../queries/qna.graphql';

export const withAddQuestion = Component => props => {
  const { productImage, productId, productName, dispatchMetrics } = props;
  const [postQuestion, { loading }] = useMutation(addQuestionQuery, { errorPolicy: 'all' });

  const questionInfo = {
    product: { id: productId, name: productName, image: getIn(productImage, [0, 'medium']) },
  };

  const addQuestion = async questionText => {
    const result = await postQuestion({ variables: { ...questionInfo, question: questionText } });

    const erroValidation = result.data?.addQuestion?.validationErrors;

    dispatchMetrics('event:track', {
      category: 'qna-pdp',
      action: 'enviar-pergunta',
      label: erroValidation === null ? 'sucesso' : 'erro',
    });

    return { result, loading };
  };

  return <Component addQuestion={addQuestion} {...props} />;
};

export default compose(withLoginRequiredToken, withCustomer, withMetrics, withAddQuestion);
